import endpoints from '@/endpoints';
import { http } from '@/utils/HttpClient';
import { ApiResponse } from '@/types/api';
import { User } from '@/types/models/user';

export const userService = {
  /**
   * Gets a user by their ID
   * @param id The ID of the user to retrieve
   * @returns A promise that resolves to the user object if successful, or a rejected promise if not
   */
  async getUser(id: string): Promise<ApiResponse<User>> {
    return await http.fetch({
      method: endpoints.user.getUser.method,
      endpoint: endpoints.user.getUser.url(id),
    });
  },
};
